// Date/time helpers for the planning screens.
//
// The lesson time is a *wall-clock* value (e.g. 18:30), but it is stored as a
// Firestore Timestamp. The bug was feeding IonDatetime `date.toISOString()`
// (UTC), then compensating with an asymmetric timezone shift on load only, which
// made the stored time drift on every edit. The fix is to never go through UTC
// in the UI: build a *local* ISO string (no `Z`) from the date's local
// components, so what you see equals what you save, with no shift.

const pad = (n) => String(n).padStart(2, "0");

// Local ISO string WITHOUT timezone designator, e.g. "2026-06-01T18:30:00".
// IonDatetime treats a value without offset as local wall-clock, so this round
// trips cleanly (display === stored), unlike toISOString() which is UTC.
export const toLocalISO = (date) => {
  const d = date instanceof Date ? date : new Date(date);
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:00`
  );
};

// Local midnight of the given date — for date-only fields, to avoid the
// off-by-one that comes from parsing a UTC ("...Z") instant in a +offset zone.
export const startOfLocalDay = (date) => {
  const d = date instanceof Date ? new Date(date) : new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};
